import styled, { css } from 'styled-components';
import { darken } from 'polished';

export const Container = styled.div`
  padding: 20px;
  color: #e9ecef;
  overflow-y: auto;
  &::-webkit-scrollbar-track {
    background-color: #2a3142;
  }
  &::-webkit-scrollbar {
    width: 6px;
    background: #eee;
  }
  &::-webkit-scrollbar-thumb {
    background: #eee;
  }

  h4 {
    color: #e9ecef;
    font-size: 18px;
    line-height: 30px;
    font-weight: 700;
  }

  span {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
    font-family: 'Roboto', sans-serif;
  }
`;

export const Button = styled.button.attrs({
  type: 'submit',
})`
  background: #626ed4;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0;
  padding: 10px;
  color: #fff;
  border-radius: 4px;
  transition: background 0.2s;

  &:hover {
    background: ${darken(0.04, '#626ed4')};
  }
`;

export const Table = styled.table`
  background: #2a3142;
  flex: 1;
  width: 100%;
  text-align: left;
  border-collapse: collapse;
  cursor: grab;

  th {
    padding: 20px 0;

    & + th {
      text-align: right;
    }
  }
`;

export const BtAcao = styled.button`
  background: ${props => (props.inativo === 1 ? '#ec4561' : '#626ed4')};
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0;
  padding: 7px 15px;
  color: #fff;
  border-radius: 4px;
  transition: background 0.2s;

  ${props =>
    props.inativo === 1
      ? css`
          &:hover {
            background: ${darken(0.04, '#ec4561')};
          }
        `
      : css`
          &:hover {
            background: ${darken(0.04, '#626ed4')};
          }
        `}

  & + button {
    margin-left: 10px;
  }
`;

export const Block = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const NewButton = styled.button`
  background: #626ed4;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0;
  padding: 10px;
  color: #fff;
  border-radius: 4px;
  transition: background 0.2s;

  &:hover {
    background: ${darken(0.04, '#626ed4')};
  }

  & + button {
    margin-left: 5px;
  }

  svg {
    margin-right: 5px;
  }
`;

export const PageActions = styled.div`
  padding-top: 20px;
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 12px;
  button {
    transition: opacity 0.25s ease-out;
    background: #626ed4;
    color: #fff;
    border-radius: 4px;
    outline: 0;
    border: 0;
    padding: 8px;
    &:disabled {
      opacity: 0.35;
      cursor: not-allowed;
    }
  }

  span {
    padding: 0 10px;
  }
`;

export const Menus = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 20px;
`;

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  text-align: center;

  span {
    color: #fff;
    padding: 10px 0;
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 20px;
  }
`;

export const ModalMenus = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    flex: 1;
    background: #626ed4;
    border: 0;
    padding: 15px 0;
    border-radius: 4px;
    color: #fff;

    & + button {
      margin-left: 10px;
      background: #ec4561;
    }
  }
`;

export const SemDados = styled.div`
  padding: 40px 0;
  display: flex;
  justify-content: center;

  h2 {
    color: rgba(255, 255, 255, 0.19);
  }
`;
